import $ from "jquery";
require("datatables.net")(window, $); // import doesn't work with v11, datatables are only "imported" using require
// import "datatables.net-dt/css/jquery.datatables.css"; // Imported via Sass

const $typeFilter = $(".js-fund-type-filter");
const $rangeFilter = $(".js-fund-range-filter");
let noRangeFiltersVisible = true;

function populateRangeDropdownAccordingToType(type) {
  // Get a list of ranges that are available on currently visible entries
  const visibleRanges = [];
  $('[data-fund-type="' + type + '"]').each(function (k, v) {
    const $row = $(v);
    const range = $row.data("fund-range");
    if (range && visibleRanges.indexOf(range) === -1) {
      visibleRanges.push(range);
    } else {
      // Not added because it already exists in the array
    }
  });

  // Check if this option's value is in the list of available ranges, and hide/show appropriately
  noRangeFiltersVisible = true;
  $rangeFilter.find("option").each(function (k, v) {
    const $option = $(v);
    if (type === "null" || $option.attr("value") === "null" || visibleRanges.indexOf($option.attr("value")) !== -1) {
      $option.show();
    } else {
      $option.hide();
    }
    if (visibleRanges.indexOf($option.attr("value")) !== -1) {
      noRangeFiltersVisible = false;
    }
  });
}

function recalculateResultCount() {
  $(".js-fund-result-count").text($(".js-fund-table-row").length);
}

function init(): void {
  $(document).ready(function () {
    // Custom search that takes selected range/type into account
    $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
      const typeFilter = $typeFilter.val();
      const rangeFilter = $rangeFilter.val();
      const type = data[4];
      const range = data[5];
      // console.log(data);
      // console.log(rangeFilter);
      // console.log(typeFilter);
      if (
        (rangeFilter === "null" && typeFilter === "null") ||
        (rangeFilter == range && typeFilter === "null") ||
        (rangeFilter == range && typeFilter == type) ||
        (rangeFilter === "null" && typeFilter == type)
      ) {
        return true;
      }
      return false;
    });

    const table = $(".js-fund-table").DataTable({
      autoWidth: false,
      info: false, // Display a "Showing X of Y results" info text line
      lengthChange: false, // Ability to change page size
      ordering: false, // Sorting
      paging: false, // Pagination
      searching: true, // Searching
      stateSave: false, // Maintain search and other options in params
    });
    $typeFilter.change(function () {
      const val = $(this).val();
      $rangeFilter.val("null");
      table.draw();
      populateRangeDropdownAccordingToType(val);
      if (val === "null" || noRangeFiltersVisible) {
        $rangeFilter.parents(".js-fund-filter").hide();
      } else {
        $rangeFilter.parents(".js-fund-filter").show();
      }
      recalculateResultCount();
    });
    $rangeFilter.change(function () {
      table.draw();
      recalculateResultCount();
    });
  });
}

export default { init };
